module.exports = __webpack_public_path__ + "img/a4.7c8cc4fb.png";